<template>
  <freight-list :type="0"></freight-list>
</template>

<script>
import FreightList from "@view/components/freight/freight-list.vue";

export default {
  name: "",
  components: {FreightList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
